export default __webpack_public_path__ + "static/CXOsync-h-86846e67081a76f800d174817d1527af.png";